/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  /**
   * Collection Price Filter: Dynamic Minimum Value
   * Ensures the minimum price shown and the slider lower limit always reflects
   * the cheapest product in the entire currently opened collection (not just the current page).
   */
  var isUpdating = false;

  function updateCollectionPriceFilter() {
    if (isUpdating) return;

    var rangeHolder = document.querySelector('[data-range-holder][data-collection-handle]');
    if (!rangeHolder) return;

    var collectionHandle = rangeHolder.getAttribute('data-collection-handle');
    if (!collectionHandle) return;

    var slider = rangeHolder.querySelector('[data-range-slider]');
    var priceMinInput = rangeHolder.querySelector('[data-field-price-min]');
    if (!slider || !priceMinInput) return;

    var cacheKey = 'ss_collection_cheapest_price_' + collectionHandle;
    var cachedData = null;
    try {
      cachedData = sessionStorage.getItem(cacheKey);
    } catch (e) {
      // sessionStorage unavailable (e.g. private browsing restriction)
    }

    if (cachedData !== null) {
      var minPrice = parseFloat(cachedData);
      if (!isNaN(minPrice) && minPrice >= 0) {
        applyMinPrice(minPrice, rangeHolder, slider, priceMinInput);
        return;
      }
    }

    // Fetch from the alternate view template (?sort_by=price-ascending&view=cheapest)
    var collectionUrl = rangeHolder.getAttribute('data-collection-url') || window.location.pathname;
    collectionUrl = collectionUrl.split('?')[0].split('#')[0];

    var endpoint = collectionUrl + '?sort_by=price-ascending&view=cheapest';

    fetch(endpoint)
      .then(function(res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function(data) {
        if (data && typeof data.min_price !== 'undefined') {
          var fetchedMin = parseFloat(data.min_price);
          if (!isNaN(fetchedMin)) {
            try {
              sessionStorage.setItem(cacheKey, String(fetchedMin));
            } catch (e) {}
            applyMinPrice(fetchedMin, rangeHolder, slider, priceMinInput);
          }
        }
      })
      .catch(function(err) {
        console.warn('[CollectionPriceFilter] Could not fetch collection cheapest price:', err);
      });
  }

  function applyMinPrice(minPrice, rangeHolder, slider, priceMinInput) {
    var roundedMinPrice = Math.round(minPrice);
    var currentMinAttr = slider.getAttribute('data-se-min');

    // If already set to this minimum, avoid duplicate updates
    if (currentMinAttr === String(roundedMinPrice)) {
      return;
    }

    isUpdating = true;

    try {
      // 1. Set the minimum bound on the slider
      slider.setAttribute('data-se-min', String(roundedMinPrice));

      // 2. Set min attribute on the "From" input
      priceMinInput.min = roundedMinPrice;

      // 3. Determine if an active user-applied min filter exists in URL
      var urlParams = new URLSearchParams(window.location.search);
      var paramName = priceMinInput.name;
      var activeFilterValue = urlParams.get(paramName);
      var hasActiveMinFilter = activeFilterValue !== null && activeFilterValue !== '' && parseFloat(activeFilterValue) > roundedMinPrice;

      if (!hasActiveMinFilter) {
        // When no active min filter is applied:
        // Set slider starting value to the collection cheapest product
        slider.setAttribute('data-se-min-value', String(roundedMinPrice));

        // Show the collection cheapest product as placeholder
        priceMinInput.placeholder = String(roundedMinPrice);

        // If input had 0 or a value <= minPrice, clear value so it acts as default
        if (priceMinInput.value !== '' && parseFloat(priceMinInput.value) <= roundedMinPrice) {
          priceMinInput.value = '';
        }
      } else {
        priceMinInput.placeholder = String(roundedMinPrice);
      }

      // 4. Trigger theme:filters:init so Palo Alto's RangeSlider recalculates left pin position & scale
      document.dispatchEvent(new CustomEvent('theme:filters:init', { bubbles: true }));
    } finally {
      setTimeout(function() {
        isUpdating = false;
      }, 60);
    }
  }

  // Hook into DOM lifecycle and theme events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCollectionPriceFilter);
  } else {
    updateCollectionPriceFilter();
  }

  // Re-run when collection filters re-render (e.g. user toggles tags, swatches, or sorts)
  document.addEventListener('theme:filters:init', function() {
    if (!isUpdating) {
      updateCollectionPriceFilter();
    }
  });
})();
